import React, { useId } from "react";
import "./Ecosystem.css";
import { useTheme } from "@mui/material";
import TrendWebImg from "../../assets/images/trendweb.png";
import TrendifyTokenImg from "../../assets/images/trendifytoken.png";
import TrendDxImg from "../../assets/images/trenddx.png";

const ProductCard = ({ data, delay }) => {
    const isComingSoon = data.cta === "Coming Soon";

    const handleClick = (e) => {
        if (isComingSoon) {
            e.preventDefault();
        }
    };

    return (
        <a
            href={data.link}
            target={isComingSoon ? "_self" : "_blank"}
            rel="noopener noreferrer"
            className="ecosystem-card"
            style={{ transitionDelay: delay }}
            onClick={handleClick}
        >
            <div className="ecosystem-card-icon-wrapper">
                <img
                    src={data.image}
                    alt={data.title}
                    className="ecosystem-icon-img"
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
            </div>

            <h3 className="ecosystem-card-title">{data.title}</h3>
            <p className="ecosystem-card-tagline">{data.tagline}</p>

            <ul className="ecosystem-card-features">
                {data.features.map((feature, idx) => (
                    <li key={idx}>
                        <svg className="feature-check" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span>{feature}</span>
                    </li>
                ))}
            </ul>

            <div className={`ecosystem-card-cta ${isComingSoon ? 'disabled' : ''}`}>
                <span>{data.cta}</span>
                <svg className="cta-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
        </a>
    );
};

const Ecosystem = () => {
    const id = useId();
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const productData = [
        {
            id: `${id}-1`,
            image: TrendWebImg,
            title: "TrendifyWeb",
            tagline: "AI-Powered Website Builder",
            features: [
                "Advanced AI orchestration",
                "State-of-the-art templates",
                "One-click deployment"
            ],
            cta: "Build Your Site",
            link: "https://trendifyweb.ai/",
        },
        {
            id: `${id}-2`,
            image: TrendifyTokenImg,
            title: "Trendify Token",
            tagline: "Empowering Next-Gen Innovations",
            features: [
                "Gateway to Future of Crypto",
                "Advanced Token Utility",
                "Community Governance"
            ],
            cta: "Learn More",
            link: "https://trendifytokens.io/",
        },
        {
            id: `${id}-3`,
            image: TrendDxImg,
            title: "Trenddx",
            tagline: "Lightning-Fast DEX",
            features: [
                "Optimized liquidity routing",
                "Secure token swaps",
                "Minimal slippage"
            ],
            cta: "Coming Soon",
            link: "",
        },
    ];

    return (
        <section id="products" className="ecosystem-section-wrapper" data-theme={isDark ? 'dark' : 'light'}>
            <div className="ecosystem-outer-container">
                <div className="ecosystem-header">
                    <span className="ecosystem-badge">ECOSYSTEM</span>
                    <h2 className="ecosystem-heading mt-2">Unified Web3 Platform</h2>
                    <p className="ecosystem-subtext mt-3">
                        Enterprise-grade tools for the modern blockchain pioneer. Build, promote, and trade with institutional precision.
                    </p>
                </div>

                <div className="ecosystem-grid">
                    {productData?.map((card, index) => (
                        <ProductCard
                            data={card}
                            key={card.id}
                            delay={`${(index + 1) * 0.15}s`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Ecosystem;
